var path = 'app/scripts/modules/dcos/pipeline/stages/destroyAsg/destroyAsgStage.html';
var html = "<div ng-controller=\"dcosDestroyAsgStageCtrl as destroyAsgStageCtrl\" class=\"form-horizontal\">\n  <div ng-if=\"!pipeline.strategy\">\n    <account-region-cluster-selector\n      application=\"application\"\n      component=\"stage\"\n      accounts=\"accounts\" >\n    </account-region-cluster-selector>\n  </div>\n  <stage-config-field label=\"Target\">\n    <target-select model=\"stage\" options=\"targets\"></target-select>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/pipeline/stages/destroyAsg/destroyAsgStage.html
// module id = 1734
// module chunks = 0